<!-- 登录设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea LoginSetting">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="登录" name="1">
            <el-form ref="form" :model="settingform" label-width="130px" class="w500">
              <el-form-item label="登录后展示页面:">
                <el-select class="select" v-model="settingform.show_page" placeholder="请选择">
                  <el-option
                    v-for="(item) in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-save" type="primary" @click="loginSetting()">保 存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <template v-if="is_admin == '1'">
          <el-tab-pane label="告警提醒" name="2">
            <el-form ref="form2" :rules="rules" :model="settingform" label-width="130px" class="w500">
              <el-form-item prop="remind">
                <template slot="label">
                  设置提醒人
                  <el-tooltip class="item" effect="dark" content="设置告警提醒人，一旦平台发生故障（如服务器崩溃、MQTT断线等情况），会第一时间发邮件和短信告知设置人员" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
                <el-select class="select" multiple v-model="settingform.remind" placeholder="请选择平台员工">
                  <el-option
                    v-for="(item) in remindList"
                    :key="item.user_id"
                    :label="item.user_name"
                    :value="item.user_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-save" type="primary" @click="submitForm('form2','1')">保 存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="短信配置" name="3">
            <el-form ref="form3" :rules="rules" :model="settingform" label-width="130px" class="w500">
              <el-form-item label="短信供应商:" prop="smsSupplier">
                <el-select class="select" v-model="settingform.smsSupplier">
                  <el-option
                    v-for="(item) in suppList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="settingform.smsSupplier != 3">
                <el-button class="btn-save" type="primary" @click="submitForm('form3','2')">保存</el-button>
              </el-form-item>
            </el-form>
            <el-form ref="msgForm" :rules="msgRules" :model="msgSettingForm" label-width="130px" class="w500" v-if="settingform.smsSupplier == 3">
              <p class="msgFormText">移动短信网关配置</p>
              <el-form-item label="请求地址:" prop="Url">
                <el-input v-model="msgSettingForm.Url" placeholder="请输入请求地址"></el-input>
              </el-form-item>
              <el-form-item label="企业账号:" prop="Eid">
                <el-input v-model="msgSettingForm.Eid" placeholder="请输入企业账号"></el-input>
              </el-form-item>
              <el-form-item label="用户名:" prop="Userid">
                <el-input v-model="msgSettingForm.Userid" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="密码:" prop="Password">
                <el-input v-model="msgSettingForm.Password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="扩展号:" prop="ExtendAccessNum">
                <el-input v-model="msgSettingForm.ExtendAccessNum" placeholder="请输入扩展号"></el-input>
              </el-form-item>
              <el-form-item label="密钥:" prop="Key">
                <el-input v-model="msgSettingForm.Key" placeholder="请输入密钥"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-save" type="primary" @click="submitMsgForm">保 存</el-button>
              </el-form-item>
            </el-form>

          </el-tab-pane>
          <el-tab-pane label="信息配置" name="4">
            <el-form ref="form4" :rules="rules" :model="settingform" label-width="130px" class="w500">
              <el-form-item label="客服电话:" prop="tel">
                <el-input v-model="settingform.tel" placeholder="客服电话"></el-input>
              </el-form-item>
              <el-form-item label="上班时间:" prop="time">
                <el-time-picker
                  is-range
                  v-model="settingform.time"
                  range-separator="至"
                  start-placeholder="上班时间"
                  end-placeholder="下班时间"
                  placeholder="选择时间范围"
                  value-format="HH:mm"
                  :picker-options="{format:'HH:mm'}">
                </el-time-picker>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-save" type="primary" @click="submitForm('form4','3')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          </template>
        </el-tabs>
        <!-- <span class="lable">登录后展示页面：</span>
        <div class="selectBox">
          <el-select class="select" v-model="show_page" placeholder="请选择">
            <el-option
              v-for="(item) in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button class="btn-save" type="primary" @click="loginSetting()">保 存</el-button>
        </div> -->
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import {
    showToast,
    showLoading,
    hideLoading,
    localUserInfo
  } from "../../../../static/js/utility/utility.js"
  import { loginApi } from "../../../../static/js/api.js"

  export default {
    name: 'LoginSetting',
    components: {
      BreadCrumb
    },
    data() {
      return {
        settingform:{
          show_page: '',//登录展示页设置
          remind:[],//设置提醒人
          smsSupplier:'',//默认短信供应商
          tel:'',//客服电话
          time:['09:00','18:00'],//上下班时间
        },
        rules:{
          remind: [
            { required: true, message: '请选择提醒人', trigger: 'blur' },
          ],
          smsSupplier: [
            { required: true, message: '请选择短信供应商', trigger: 'blur' },
          ],
          tel: [
            { required: true, message: '请输入电话号码', trigger: 'blur' },
          ],
          time: [
            { required: true, message: '请设置上班时间', trigger: 'blur' },
          ],
        },
        options: [
          {
            label: '仪表盘',
            value: '1'
          },
          {
            label: '平台默认首页',
            value: '2'
          }
        ],
        remindList:[],
        suppList:[
          {
            id:'',
            name:'请选择短信供应商'
          },
          {
            id:'1',
            name:'蜂助手'
          },
          {
            id:'2',
            name:'云通讯'
          },
          {
            id:'3',
            name:'移动短信'
          },
        ],

        tabActive:'1',//tab当前选中
        is_admin:'',

        msgSettingForm: {
          Url: '',
          Eid: '',
          Userid: '',
          Password: '',
          ExtendAccessNum: '',
          Key: ''
        },
        msgRules: {
          Url: [
            { required: true, message: '请输入请求地址', trigger: 'blur' },
          ],
          Eid: [
            { required: true, message: '请选择企业账户', trigger: 'blur' },
          ],
          Userid: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          Password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          ExtendAccessNum: [
            { required: true, message: '请输入扩展号', trigger: 'blur' },
          ],
          Key: [
            { required: true, message: '请输入密钥', trigger: 'blur' },
          ],
        },
      }
    },
    mounted(){
      let show_page = JSON.parse(localStorage.getItem('userInfo')).show_page
      this.settingform.show_page = show_page
    },
    created: async function () {
      this.is_admin = localUserInfo.getItem().is_admin
      if(this.is_admin == '1'){
        this.getUser()
        this.getParams()
      }
    },
    methods: {
      // 4.0S 获取短信配置信息
      async GetSmsConfig () {
        let vm = this
        // console.log('smsSupplier', vm.settingform.smsSupplier)
        let data = { SmsType: 3 }
        let res = await loginApi.GetSmsConfig(data)
        if (res.ErrCode === 0) {
          if (res.Result) {
            vm.msgSettingForm = JSON.parse(res.Result.Content)
          }
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 4.0S 编辑/添加短信配置
	    async SetYdConfig () {
        let vm = this
        let data = vm.msgSettingForm
        let res = await loginApi.SetYdConfig(data)
        if (res.ErrCode === 0) {
          showToast('设置成功')
        } else {
          showToast(res.meta.message)
        }
      },
      // 校验短信表单提交
      submitMsgForm () {
        let vm = this
        this.$refs.msgForm.validate((valid) => {
          if (valid) {
            vm.setParams('2')
          } else { return false;}
        });
      },
      //校验提交
      submitForm(formName,type){
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.setParams(type)
          } else { return false;}
        });
      },
      //更新基本设置
      async setParams(type){
        let that = this;
        var content
        if(type == '1'){
          content = this.settingform.remind.join(',')
        }else if(type == '2'){
          content = this.settingform.smsSupplier
        }else if(type == '3'){
          content = this.settingform.tel
        }
        var dataObj = {
          'type': type,
          'content': content,
        }
        if(type == '3'){
          dataObj.go_time = this.settingform.time[0]
          dataObj.off_time = this.settingform.time[1]
        }
        const res = await loginApi.setParams(dataObj);
        if(res.meta.code == 200){
          if (type == '2' && content == 3) {
            that.SetYdConfig()
          } else {
            showToast('设置成功！')
            that.getParams()
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //获取基本设置
      async getParams(){
        let that = this;
        const res = await loginApi.getParams();
        if(res.meta.code == 200){
          for(let i in res.data){
            if(res.data[i].type == '1'){
              that.settingform.remind = res.data[i].content.split(',');
            }else if(res.data[i].type == '2'){
              that.settingform.smsSupplier = res.data[i].content;
            }else{
              that.settingform.tel = res.data[i].content;
              that.settingform.time[0] = res.data[i].go_time;
              that.settingform.time[1] = res.data[i].off_time;
            }
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //获取员工列表
      async getUser(){
        let that = this;
        const res = await loginApi.getUser();
        if(res.meta.code == 200){
          this.remindList = res.data
        }
      },
      // 改变show_page，更新userInfo
      updateUserInfo: function (new_show_page) {
        let newUserInfo = JSON.parse(localStorage.getItem('userInfo'))
        newUserInfo.show_page = new_show_page
        localStorage.setItem('userInfo', JSON.stringify(newUserInfo))
      },
      // 登录设置
      loginSetting: async function () {
        let vm = this
        let data = {
          show_page: this.settingform.show_page
        }
        showLoading('保存设置中')
        let res = await loginApi.loginSetting(data)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('设置成功')
          vm.updateUserInfo(data.show_page)
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      "tabActive":async function(newVal, oldVal) {
        console.log('newVal', newVal)
        if (newVal == 3) {
          this.GetSmsConfig()
        }
      }
    }
  }
</script>

<style lang="scss">
.LoginSetting{
  // tabs标签
  .el-tabs__header {
    width: 100%;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #E4E7ED;
    .el-tabs__nav-wrap {
      padding-left: 20px;
      // width: 360px;
    }
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .lable {
      float: left;
      line-height: 40px;
    }
  .selectBox {
    margin-left: 130px;
    .select {
      margin-bottom: 20px;
    }
    .btn-save {
      display: block;
    }
  }
  .w500{
    width: 500px;
  }
  .el-select{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/Other/LoginSetting.vue